import styled from 'styled-components';
export const Container = styled.div`
  text-align : left;
`;
export const TitleWrap = styled.div`
  padding : 20px 28px;
  border-bottom : 1px solid #dddddd;
  text-align : inherit;
`
export const Title = styled.div`
  font-size : 24px;
  font-weight : bold;
  margin-bottom  : 15px;
  text-align : inherit;
`;
export const Text = styled.div`
    text-align : inherit;
  font-size : ${props=> props.fontSize ? props.fontSize : "14px"};
  font-weight : 100;
  color : ${props => props.color ? props.color : "inherit"};
`
export const SubTitleWrap = styled.div`
  display : flex;
  align-items : flex-end;
  margin-bottom : 5px;
`
export const SubTitle = styled.div`
  text-align : inherit;
  font-size : 18px;
  font-weight : bold;
  margin-right : 10px;
`
export const Div = styled.div`
  display : flex;
  flex-direction : ${props => props.direction ? "column" : "row"};
  justify-content : ${props=> props.justify ? props.justify : "space-between"};
  margin : ${props => props.margin? props.margin : 0};
  padding : ${props => props.padding? props.padding : 0};
  border-top : ${props => props.borderTop ? "1px solid #ddd" : props.borderTop};
  svg{
    width : 20px;
  }
`;
export const Button = styled.button`
    background : ${props=> props.cancel ? "#eee" : "#424242"};
    color : ${props=> props.cancel ? "black" : "#fff"};
    border : 1px solid ${props=> props.cancel ? "#eee" : "#424242"};
    width :100%;
    height : 30px;
    max-width : 75px;
    margin : ${props => props.margin? props.margin : 0};
    border-radius : 5px;
    cursor: pointer;
    &:hover{
        
    }
`;